import { CarouselManager } from "../utils/carouselManager";

class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this.loop = this.dataset.loop === "true";
  }

  async connectedCallback() {
    await this.initSlider();
    await this.initThumbnailsSlider();
  }

  async initSlider() {
    const splideEl = this.querySelector(".js-product-main-slider");

    let options = {
      type: this.loop ? "loop" : "slide",
      perPage: 1,
      gap: 8,
      pagination: false,
      arrows: false,
    };

    // Let CarouselManager handle initialization and observation
    this.splide = await CarouselManager.create(splideEl, options);
    if (this.dataset.lazyloadSection === "true") {
      await this.fetchItems();
      if(this.splide) {
        this.splide.refresh();
      }
    }

    if (this.dataset.arrows === "true") {
      this.initSliderArrows();
    }
    this.classList.add("js-loaded");
  }

  initSliderArrows() {
    const sliderNavEl = this.querySelector(".slider-nav");
    if (sliderNavEl) {
      const navNextBtn = sliderNavEl.querySelector(".nav-next");
      const navPrevBtn = sliderNavEl.querySelector(".nav-prev");

      navNextBtn.addEventListener("click", () => {
        this.splide.go(">");
      });

      navPrevBtn.addEventListener("click", () => {
        this.splide.go("<");
      });
    } else {
      console.warn("No slider nav found");
    }
  }

  get visibleSlides() {
    if (!this.splide) return 1;
    if(!this._visibleSlides || this._windowWidth !== window.innerWidth) {
      this._windowWidth = window.innerWidth;
      this._visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length
    }
    return this._visibleSlides;
  }

  async initThumbnailsSlider() {
    const thumbnailsSliderEl = this.querySelector(".js-product-thumbnails-slider");
    if (thumbnailsSliderEl && this.splide) {
      this.thumbnailsSlider = await CarouselManager.create(thumbnailsSliderEl, {
        type: "slide",
        direction: 'ttb',
        perPage: 3,
        heightRatio: 3.279,
        fixedWidth  : 129,
        fixedHeight : 129,
        gap: 12,
        pagination: false,
        arrows: false,
        isNavigation: true,
        mediaQuery: 'min',
        breakpoints : {
          1314: {
            perPage: 4,
            heightRatio: 4.37,
          },
        },    
      });

      this.splide.sync( this.thumbnailsSlider );
    }
  }
}

customElements.define('product-gallery', ProductGallery);